<template>
	<iframe ref="iframe" :src="urlPath" class="iframe" />
</template>

<script>
import {mapGetters} from 'vuex'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
export default {
	name: 'AvueIframe',
	components: {
		...mapGetters(['screen']),
	},
	props: ['routerPath'],
	data() {
		return {
			//https://www.meibaokeji.com.cn/employer/static/truth.html
			//https://mbtest.meibaokeji.com.cn/employer/static/truth.html?isHide=1
			urlPath: 'https://www.meibaokeji.com.cn/employer/static/truth.html?isHide=1', // iframe src 路径
		}
	},
	watch: {},
	created() {
		NProgress.configure({showSpinner: false})
	},
	mounted() {
		this.load()
		this.resize()
	},
	methods: {
		// 显示等待框
		show() {
			NProgress.start()
		},
		// 隐藏等待狂
		hide() {
			NProgress.done()
		},
		// 加载浏览器窗口变化自适应
		resize() {
			window.onresize = () => {
				this.iframeInit()
			}
		},
		// 加载组件
		load() {
			this.show()
			this.iframeInit()
		},
		// iframe窗口初始化
		iframeInit() {
			const iframe = this.$refs.iframe
			const clientHeight = document.documentElement.clientHeight - (screen > 1 ? 200 : 130)
			// iframe.style.height = `${clientHeight}px`
			if (iframe.attachEvent) {
				iframe.attachEvent('onload', () => {
					this.hide()
				})
			} else {
				iframe.onload = () => {
					this.hide()
				}
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.iframe {
	width: 100%;
	height: 98vh;
	box-sizing: border-box;
}
</style>
